import React, { useState } from "react";
import { useNavigate } from "react-router-dom";


const inp = {
  width: "100%", padding: "16px 18px", borderRadius: 16,
  border: "1.5px solid #E5E5EA", background: "#FAFAFA",
  fontSize: 16, color: "#0f0f17", outline: "none",
  boxSizing: "border-box", fontFamily: "-apple-system, BlinkMacSystemFont, system-ui",
  fontWeight: 500
};

export default function ContactPageMobile() {
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
const navigate = useNavigate();
  const handleSubmit = async e => {
    e.preventDefault();
    const form = e.target;
    setSubmitting(true);
    try {
      const res = await fetch("https://eleven11-i6v4.onrender.com/api/messages", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name: form.name.value,
          email: form.email.value,
          phone: form.phone.value,
          company: form.company.value,
          message: form.message.value
        })
      });
      if (res.ok) { setSubmitted(true); form.reset(); }
    } catch { alert("Something went wrong. Please try again."); }
    finally { setSubmitting(false); }
  };

  return (
    <div style={{ background: "#F4F5F7", minHeight: "100vh", fontFamily: "-apple-system, BlinkMacSystemFont, 'SF Pro Text', system-ui", paddingBottom: 60 }}>

      {/* Hero */}
      <div style={{ background: "#fff", padding: "32px 20px 28px", borderBottom: "1px solid #f3f4f6" }}>
        <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: 3, color: "#9CA3AF", marginBottom: 8 }}>ELEVEN MARINE</div>
        <h1 style={{ margin: "0 0 12px", fontSize: 40, fontWeight: 800, letterSpacing: "-2px", color: "#0f0f17", lineHeight: 1.05 }}>Contact</h1>
        <p style={{ margin: 0, fontSize: 16, color: "#6E6E73", lineHeight: 1.6, fontWeight: 400 }}>
          Speak with ELEVEN regarding OEM watercraft parts, products, dealer accounts, logistics, or wholesale distribution.
        </p>
      </div>

      <div style={{ padding: "20px 16px 0" }}>

        {/* Quick contact */}
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, marginBottom: 16 }}>
          <a href="mailto:elevensalesinfo@gmail.com" style={{ display: "flex", flexDirection: "column", gap: 6, padding: "16px 14px", background: "#fff", borderRadius: 18, textDecoration: "none", boxShadow: "0 1px 3px rgba(0,0,0,0.06)" }}>
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#374151" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
            <span style={{ fontSize: 11, fontWeight: 700, color: "#9ca3af", textTransform: "uppercase", letterSpacing: 0.8 }}>Email</span>
            <span style={{ fontSize: 12, fontWeight: 600, color: "#0f0f17", lineHeight: 1.4 }}>elevensalesinfo@gmail.com</span>
          </a>
          <a href="tel:+13057836077" style={{ display: "flex", flexDirection: "column", gap: 6, padding: "16px 14px", background: "#fff", borderRadius: 18, textDecoration: "none", boxShadow: "0 1px 3px rgba(0,0,0,0.06)" }}>
         <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#374151" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.81a19.79 19.79 0 01-3.07-8.67A2 2 0 012 1.17h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.09 8.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z"/></svg>
            <span style={{ fontSize: 11, fontWeight: 700, color: "#9ca3af", textTransform: "uppercase", letterSpacing: 0.8 }}>Phone</span>
            <span style={{ fontSize: 12, fontWeight: 600, color: "#0f0f17" }}>(305) 783-6077</span>
          </a>
        </div>

        {/* Info cards */}
        <div style={{ background: "#fff", borderRadius: 20, marginBottom: 16, overflow: "hidden", boxShadow: "0 1px 3px rgba(0,0,0,0.06)" }}>
          {[
            {
              label: "Customer Support",
          icon: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="4"/><line x1="4.93" y1="4.93" x2="9.17" y2="9.17"/><line x1="14.83" y1="14.83" x2="19.07" y2="19.07"/><line x1="14.83" y1="9.17" x2="19.07" y2="4.93"/><line x1="4.93" y1="19.07" x2="9.17" y2="14.83"/></svg>,
              items: ["OEM Parts Orders", "Shipping Support", "Returns & Warranty", "General Assistance"]
            },
            {
              label: "Dealer & Wholesale",
   icon: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87"/><path d="M16 3.13a4 4 0 010 7.75"/></svg>,
              items: ["Dealer Accounts", "Bulk Inventory Orders", "Distribution Partnerships"]
            },
            {
              label: "Business Hours",
icon: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>,
              items: ["Monday – Friday", "9:00 AM – 6:00 PM EST"]
            }
          ].map((card, i, arr) => (
            <div key={card.label} style={{ padding: "18px 18px", borderBottom: i < arr.length - 1 ? "1px solid #f3f4f6" : "none" }}>
              <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 10 }}>
{card.icon}
                <span style={{ fontSize: 11, fontWeight: 800, color: "#9ca3af", letterSpacing: 1.2, textTransform: "uppercase" }}>{card.label}</span>
              </div>
              {card.items.map(item => (
                <div key={item} style={{ fontSize: 14, color: "#374151", fontWeight: 500, lineHeight: "28px" }}>{item}</div>
              ))}
            </div>
          ))}
        </div>

        {/* Form */}
        <div style={{ background: "#fff", borderRadius: 20, marginBottom: 16, overflow: "hidden", boxShadow: "0 1px 3px rgba(0,0,0,0.06)" }}>
          <div style={{ padding: "18px 18px 0", borderBottom: "1px solid #f3f4f6", paddingBottom: 14 }}>
            <div style={{ fontSize: 22, fontWeight: 800, letterSpacing: "-0.8px", color: "#0f0f17" }}>Let's talk.</div>
            <div style={{ fontSize: 14, color: "#9ca3af", marginTop: 4 }}>We respond within one business day.</div>
          </div>

          <form onSubmit={handleSubmit} style={{ padding: "18px 18px 24px", display: "flex", flexDirection: "column", gap: 12 }}>

            {submitted && (
              <div style={{ padding: "14px 16px", background: "#EDFDF4", border: "1px solid #BBF7D0", borderRadius: 14, color: "#15803D", fontSize: 14, fontWeight: 600, textAlign: "center" }}>
                ✓ Message sent! We'll be in touch within one business day.
              </div>
            )}

            <input name="name" type="text" placeholder="Full Name" style={inp} required />
            <input name="email" type="email" placeholder="Email Address" style={inp} required />
            <input name="phone" type="tel" placeholder="Phone Number" style={inp} required />
            <input name="company" type="text" placeholder="Company (Optional)" style={inp} />
            <textarea
              name="message" placeholder="How can we help?" rows={5}
              style={{ ...inp, resize: "vertical", lineHeight: 1.6, padding: "16px 18px" }}
              required
            />

            <button
              type="submit" disabled={submitting}
              style={{ width: "100%", padding: "16px", borderRadius: 16, border: "none", background: submitting ? "#9ca3af" : "#0f0f17", color: "#fff", fontSize: 16, fontWeight: 800, cursor: submitting ? "not-allowed" : "pointer", letterSpacing: -0.3, marginTop: 4 }}
            >
              {submitting ? "Sending..." : "Send Message"}
            </button>
          </form>
        </div>

        {/* Footer */}
        <div style={{ textAlign: "center", paddingBottom: 20 }}>
          <div style={{ fontSize: 12, color: "#A1A1AA", marginBottom: 10 }}>© 2026 ELEVEN Industries</div>
          <div style={{ display: "flex", justifyContent: "center", gap: 20 }}>
       {[
  { label: "Privacy", path: "/privacy" },
  { label: "Terms", path: "/terms" },
  { label: "Dealer Program", path: "/contact" },
].map(l => (
  <span key={l.label} onClick={() => navigate(l.path)} style={{ fontSize: 12, color: "#8E8E93", cursor: "pointer" }}>{l.label}</span>
))}
          </div>
        </div>

      </div>
    </div>
  );
}